const theme = {
  token: {
    colorPrimary: "#2769CD",
    colorPrimaryBorder: "#FBE1C1",
    itemActiveBg: "rgba(255, 255, 255, 0)",
    colorLink: "#2769CD",
    colorLinkActive: "#2769CD",
    colorLinkHover: "#F5BE51",
    // colorTextDisabled: "#FFF7E8",
    contentFontSizeLG: 17.0,
    controlHeightLG: 48,
  },
  cssVar: true,
  hashed: false,
};

export default theme;
